import TruckIcon from "@redotech/redo-web/arbiter-icon/truck-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useContext, useState } from "react";
import { DateEstimateContext } from "./date-estimate-context";
import * as css from "./delivery-estimate.module.css";
import { ZipCodeContext } from "./zip-code-context";
import { ZipCodeModal } from "./zip-code-modal";

export const DeliveryEstimate = memo(function DeliveryEstimate() {
  const zipContext = useContext(ZipCodeContext);
  const dateEstimateContext = useContext(DateEstimateContext);

  const [modalOpen, setModalOpen] = useState(false);

  const customerLocale =
    globalThis.Shopify?.locale ?? navigator.language ?? "en-US";

  if (!zipContext) {
    return null;
  }

  return (
    <>
      <Flex align="center" gap="md" my="xl">
        <TruckIcon className={css.truckIcon} />
        <Flex dir="row" gap="xs">
          <p>Get it by</p>
          <p className={css.estimate}>
            {dateEstimateContext.estimatedDeliveryDate &&
            !dateEstimateContext.isLoading
              ? dateEstimateContext.estimatedDeliveryDate.toLocaleDateString(
                  customerLocale,
                  { month: "long", day: "numeric", year: "numeric" },
                )
              : "Loading..."}
          </p>
          <p>to</p>
          <p className={css.zipCode} onClick={() => setModalOpen(true)}>
            {zipContext.savedZipCode}
          </p>
        </Flex>
      </Flex>
      <ZipCodeModal onClose={() => setModalOpen(false)} open={modalOpen} />
    </>
  );
});
